<template>
  <span class="add-text" @click="clickAdd">
    <i class="iconfont ux_icon_plus"></i>
    <i>{{ $t('HT.add') }}</i>
  </span>
</template>

<script>
export default {
  methods: {
    clickAdd() {
      this.$emit('click');
    }
  }
};
</script>

<style lang="scss" scoped>
.add-text {
  padding-top: 25px;
  margin-right: auto;
  font-size: 14px;
  color: #0087ff;
  cursor: pointer;
  user-select: none;

  .iconfont {
    font-size: 14px;
  }
}
</style>
